export const GRAPH_NODE_LEGEND = [
  { shape: "circle", label: "Scripture verse", colorKey: "verse" },
  { shape: "square", label: "Conference talk", colorKey: "talk" },
  { shape: "diamond", label: "Come Follow Me lesson", colorKey: "cfm" },
  { shape: "triangle", label: "Study apparatus", colorKey: "apparatus" },
  { shape: "hexagon", label: "Foundational text / hymn", colorKey: "foundational" },
  { shape: "circle", label: "Current page (center)", colorKey: "center", isCenter: true },
]

function circlePath(radius) {
  const points = []
  for (let i = 0; i <= 24; i += 1) {
    const angle = (i / 24) * Math.PI * 2
    points.push([Math.cos(angle) * radius, Math.sin(angle) * radius])
  }
  return points
}

function squarePath(radius) {
  return [
    [-radius, -radius],
    [radius, -radius],
    [radius, radius],
    [-radius, radius],
  ]
}

function diamondPath(radius) {
  return [
    [0, -radius],
    [radius, 0],
    [0, radius],
    [-radius, 0],
  ]
}

function trianglePath(radius) {
  return [
    [0, -radius],
    [radius, radius * 0.8],
    [-radius, radius * 0.8],
  ]
}

function hexagonPath(radius) {
  const points = []
  for (let i = 0; i < 6; i += 1) {
    const angle = (Math.PI / 3) * i - Math.PI / 6
    points.push([Math.cos(angle) * radius, Math.sin(angle) * radius])
  }
  return points
}

function pointsToSvgPath(points) {
  if (!points.length) return ""
  const [firstX, firstY] = points[0]
  const rest = points
    .slice(1)
    .map(([x, y]) => `L ${x.toFixed(2)} ${y.toFixed(2)}`)
    .join(" ")
  return `M ${firstX.toFixed(2)} ${firstY.toFixed(2)} ${rest} Z`
}

export function legendShapePath(shape) {
  const radius = 7
  switch (shape) {
    case "square":
      return pointsToSvgPath(squarePath(radius))
    case "diamond":
      return pointsToSvgPath(diamondPath(radius))
    case "triangle":
      return pointsToSvgPath(trianglePath(radius))
    case "hexagon":
      return pointsToSvgPath(hexagonPath(radius))
    default:
      return pointsToSvgPath(circlePath(radius))
  }
}

export default function GraphNodeLegend({ theme }) {
  return (
    <div
      className="mt-3 rounded-md border border-border bg-surface-elevated px-3 py-2"
      aria-label="Graph node symbol key"
    >
      <p className="text-xs font-semibold uppercase tracking-wide text-text-muted">Symbol key</p>
      <ul className="mt-2 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
        {GRAPH_NODE_LEGEND.map((entry) => {
          const color = theme[entry.colorKey]
          return (
            <li key={entry.label} className="flex items-center gap-2 text-xs text-text-secondary">
              <svg width="22" height="22" viewBox="-12 -12 24 24" aria-hidden="true" className="shrink-0">
                {entry.isCenter ? (
                  <>
                    <circle cx="0" cy="0" r="10" fill="var(--surface-elevated)" stroke={color} strokeWidth="2" />
                    <path d={legendShapePath(entry.shape)} fill={color} />
                  </>
                ) : (
                  <path d={legendShapePath(entry.shape)} fill={color} />
                )}
              </svg>
              <span>{entry.label}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
